
function priceCalc(unitPrice, numItems, numDays = 1){

    return unitPrice * numItems * numDays;
}

export default priceCalc;